import { CharacterClassIcon } from 'app/frontend/base/components'
import CharacterClass, {
  classColours,
} from 'app/frontend/types/custom/CharacterClass'
import { useCharacterClasses } from 'app/frontend/base/hooks/useCharacterClasses'
import StatTable from './StatTable'
import { cn } from '@/lib/utils'

const CountByClass = ({ className }: { className?: string }) => {
  const characterClasses = useCharacterClasses()
  return (
    <StatTable<CharacterClass>
      className={className}
      title='Class'
      subject={characterClasses.reduce((acc, characterClass) => {
        acc[characterClass] = characterClass
        return acc
      }, {} as Record<CharacterClass, CharacterClass>)}
      memberFilterFn={(member, characterClass) =>
        member.characterReference.characterClass === characterClass
      }
      valueFn={(_, characterClass) => (
        <span
          className={cn(
            'flex items-center gap-1.5',
            classColours[characterClass].text,
          )}
        >
          <CharacterClassIcon characterClass={characterClass} size='small' />
          {characterClass}
        </span>
      )}
    />
  )
}

export default CountByClass
